import { render, staticRenderFns } from "./ExpensePending.vue?vue&type=template&id=ef9910e8&"
import script from "./ExpensePending.vue?vue&type=script&lang=js&"
export * from "./ExpensePending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports